exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mini_card[data-v-46dee3f0]{min-height:275px;padding:10px;display:-ms-grid;display:grid;-ms-grid-columns:1fr;grid-template-columns:1fr;-ms-grid-rows:159px 1fr 34px;grid-template-rows:159px 1fr 34px;row-gap:13px;text-decoration:none;background-color:#fff;transition:box-shadow .2s ease-in;box-shadow:3px 3px 3px rgba(0,0,0,.1)}.mini_card[data-v-46dee3f0]:hover{box-shadow:3px 3px 3px rgba(0,0,0,.2)}.mini_card__main[data-v-46dee3f0]:after{content:\"\";height:5px;width:100%;position:absolute;bottom:0;left:0}.mini_card__btn[data-v-46dee3f0]{justify-self:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46dee3f0","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/event/card/components/MiniCard.vue
// module id = 415ffabd736b94bcccb2
// module chunks = 5